var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 22.3A5 5 0 0124 27v6H0v-6a5 5 0 013.3-4.7L4 22l.2-.1c1.7-.8 4-1.8 4-2.9v-1.5a5 5 0 01-1.8-3.3c-.5-.4-1.3-1.4-1.3-2.6 0-.7.3-1.2.5-1.6-.1-.8-.4-2.4-.4-3.5 0-4 2.7-6.5 6.9-6.5 1.2 0 2.6.3 3.4 1.2 2 .3 3.5 2.6 3.5 5.3 0 1.7-.3 3-.5 3.7.2.4.4.9.4 1.5 0 1.3-.7 2.1-1.3 2.6a5 5 0 01-1.6 3.2V19c0 1 2.3 2.4 4 3l.6.3z",
    fill: "currentColor"
  })));
}

export default SvgProfile;